import React, {useState} from 'react';
import TabsMenu from '../../components/reusableElementsComponents/TabsMenu';
import HelpCenter from './HelpCenter';
import ServiceUse from './serviceUse';
import Coaching from './Coaching';
import { t } from '../../content';

export default function FaqPage() {
    const [tabActiveKey, setTabActiveKey] = useState("0");
    const activeKey = (key) => {
        setTabActiveKey(key)
    }
    const HelpCenterMemoized = React.memo(HelpCenter);


    const template = {
        tabs: [
            {
                component: <ServiceUse tabActiveKey={tabActiveKey}/>,
                sectionTitle: t('help.tabs.serviceUse')
            },
            {
                component: <Coaching tabActiveKey={tabActiveKey}/>,
                sectionTitle: t('help.tabs.analytics')
            },
            {
                component: <HelpCenterMemoized tabActiveKey={tabActiveKey}/>,
                sectionTitle: t('help.tabs.billing')
            },

        ]
    }

    return (
        <div className="bg-cover" style={{width: "100%"}}>
            <div style={{height: "100%"}}>
                <div className='img-div'>
                    <div className='first-head'>
                        <span className='first-head-text'>{t('help.heading')}</span>
                    </div>
                    <div className="tabs-wrapper tabs-styling tabs-bottom-alignment">
                        <TabsMenu template={template} activeKey={activeKey} tabActiveKey={tabActiveKey}/>
                    </div>
                </div>
            </div>

        </div>
    )
}
